import styled from "styled-components";

export const Button = styled.button`
  cursor: pointer;
  font-weight: 600;
  line-height: normal;
  display: inline-flex;
  height: ${({ height }) => height || 40}px;
  padding: 11px 17px;
  justify-content: center;
  align-items: center;
  gap: 5px;
  flex-shrink: 0;
  transition: background 0.3s ease-in-out, color 0.3s ease-in-out, border 0.3s ease-in-out;
  border-radius: 4px;
  min-width: max-content;

  font-size: var(--fs-base);

  background: ${({ theme, backgroundColor }) =>
    backgroundColor || theme.colors.campaignCreationNavigation.continueButtonBgColor};
  color: ${({ theme, color }) =>
    color || theme.colors.campaignCreationNavigation.continueButtonTextColor};
  border: ${({ theme, backgroundColor }) =>
    `1px solid ${
      backgroundColor || theme.colors.campaignCreationNavigation.continueButtonBgColor
    }`};

  &:hover {
    background: ${({ theme, backgroundColor }) =>
      backgroundColor || theme.colors.campaignCreationNavigation.continueButtonHoverBgColor};
    border: ${({ theme, backgroundColor }) =>
      `1px solid ${
        backgroundColor || theme.colors.campaignCreationNavigation.continueButtonHoverBgColor
      }`};
  }

  &:disabled {
    cursor: not-allowed;
    background: ${({ theme, backgroundColor }) =>
      backgroundColor || theme.colors.campaignCreationNavigation.continueButtonDisabledBgColor};
    color: ${({ theme, color }) =>
      color || theme.colors.campaignCreationNavigation.continueButtonDisabledTextColor};
    border: ${({ theme, backgroundColor }) =>
      `1px solid ${
        backgroundColor || theme.colors.campaignCreationNavigation.continueButtonDisabledBorderColor
      }`};
  }

  @media screen and (min-width: 1920px) and (min-device-pixel-ratio: 2),
    screen and (min-width: 1920px) and (min-resolution: 192dpi) {
    height: 39px;
    width: 70px;
  }
`;
